"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    ElevarDataLayer?: Array<Record<string, unknown>>;
  }
}

export function NotFoundAnalytics({ siteName }: { siteName: string }) {
  useEffect(() => {
    // Get full URL and strip /index.html? if present
    const href = window.location.href.replace(/\/index\.html?$/i, "");
    const pathname = window.location.pathname.replace(/\/index\.html?$/i, "");
    const referrer = document.referrer;

    // Update document title with the actual pathname
    // Use setTimeout to ensure it runs after Next.js applies server metadata
    setTimeout(() => {
      document.title = `404 Not Found | ${siteName} | ${pathname}`;
    }, 0);

    // Track analytics event
    window.ElevarDataLayer = window.ElevarDataLayer || [];

    const eventData: Record<string, string> = {
      event: "404_error",
      error_url: href,
    };

    // Only include error_message if referrer exists and differs from current page
    if (referrer && referrer !== window.location.href && referrer !== href) {
      eventData.error_message = `referred by ${referrer}`;
    }

    window.ElevarDataLayer.push(eventData);

    console.error("❌ 404 error tracked:", eventData);
  }, [siteName]);

  return null;
}
